import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { Default as DefaultHeader } from './header';
import { Default as DefaultBody, Home, PrivacyPolicy } from './body';
import { Default as DefaultFooter } from './footer';

import '../../App.css';

export const Header = () => (
  <DefaultHeader />
);

export const Body = () => (
  <Switch>
    <Route exact path="/" render={() => (<Home />)} />
    <Route path="/privacy-policy" render={() => (<PrivacyPolicy />)} />
    <Route path="/" render={() => (<DefaultBody />)} />
  </Switch>
);

export const Footer = () => (
  <DefaultFooter />
);

const layoutstyle = {
  backgroundColor: '#EEE',
};

const Layout = () => (
  <div
    className="root"
    style={layoutstyle}
  >
    <Header />
    <Body />
    <Footer />
  </div>
);

export default Layout;



// WEBPACK FOOTER //
// ./src/components/layout/index.js